module.exports = __webpack_public_path__ + "media/images/team/jason-e0f0a7b2eb556d12e603212239fbcdb8.jpg";